import type { DayNightPhase } from "../../models/dayNightPhase.ts";
import type { Season } from "../../models/season.ts";
import type { TileTerrain, Weather } from "../../models/worldState.ts";
import { createTurnRng } from "./turnSeed.ts";
import { getWeatherWeights, WEATHER_CONDITIONS } from "./weatherConfig.ts";

export function resolveWeather(
  turn: number,
  terrain: TileTerrain,
  season: Season,
  dayNightPhase: DayNightPhase,
): Weather {
  const weights = getWeatherWeights(season, dayNightPhase, terrain);
  const total = WEATHER_CONDITIONS.reduce(
    (sum, condition) => sum + weights[condition],
    0,
  );
  if (total <= 0) {
    return "clear";
  }

  const random = createTurnRng(turn);
  let roll = random() * total;
  for (const condition of WEATHER_CONDITIONS) {
    roll -= weights[condition];
    if (roll < 0) {
      return condition;
    }
  }
  return WEATHER_CONDITIONS[WEATHER_CONDITIONS.length - 1]!;
}
